'use client'

import { useCurrentUserQuery, useSigninMutation } from '@/api/index'
import { useToast } from '@/hooks/use-toast'
import { useState } from 'react'
import { LoginFormValues } from '../../_schema/types'

type UseLoginOptions = {
  onSuccess?: () => void
}

export const useLogin = (options?: UseLoginOptions) => {
  const [open, setOpen] = useState(false)
  const { toast } = useToast()
  const { refetch: refetchCurrentUser } = useCurrentUserQuery()
  const [signinMutation, { loading }] = useSigninMutation({
    onCompleted: async (data) => {
      if (!data.signin?.error) {
        await refetchCurrentUser()
        toast({
          title: 'ログインしました',
          duration: 5000,
        })
        setOpen(false)
        options?.onSuccess?.()
      } else {
        toast({
          title: 'ログインに失敗しました',
          variant: 'destructive',
          duration: 5000,
        })
      }
    },
    onError: () => {
      toast({
        title: 'ログイン中にエラーが発生しました。もう一度お試しください。',
        variant: 'destructive',
        duration: 5000,
      })
    },
  })

  const handleLogin = async (values: LoginFormValues) => {
    try {
      await signinMutation({
        variables: {
          brandId: process.env.NEXT_PUBLIC_BRAND_ID_CANADAGOOSE || '',
          email: values.email,
          password: values.password,
        },
      })
    } catch {
      toast({
        title: 'エラーが発生しました',
        variant: 'destructive',
      })
    }
  }

  return {
    open,
    setOpen,
    loading,
    handleLogin,
  }
}
